import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class RelationManagerApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }
  lookupGetList (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/getLookupList`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  lookupGetValues (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/getLookupValues`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  lookupCreate (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/lookupCreate`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  lookupModify (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/lookupModify`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  lookupDelete (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/lookupDelete`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  lookupValueCreate (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/lookupValueCreate`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  lookupValueModify (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/lookupValueModify`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  lookupValueDelete (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/lookupValueDelete`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  relationGetList (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/getRelationList`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  domainCreate (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/domainCreate`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  domainModify (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/domainModify`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  domainDelete (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/domainDelete`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getRowDrillDownLookup (data: any): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/getLookupValues`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  relationsAttributesGetList (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/getRelationsAttributeList`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getFilterReferenceList (classname): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/relationManager/getFilterReferenceList`
    return this.http.post(apiEndPoint, { classname }, this.fuseqHeaders.setTokenHeaders('POST'))
  }
}
